import { render, staticRenderFns } from "./RankingListSection.vue?vue&type=template&id=4c1c088a&scoped=true"
import script from "./RankingListSection.vue?vue&type=script&lang=ts"
export * from "./RankingListSection.vue?vue&type=script&lang=ts"
import style0 from "./RankingListSection.vue?vue&type=style&index=0&id=4c1c088a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1c088a",
  null
  
)

export default component.exports